export const periodFilterLimits = {
  maxRangeDays: 31,   // 1 month
  maxRangeWeeks: 26,  // 6 months
  maxRangeMonths: 24, // 2 years
};
